import React from 'react';
import { CollectionRow } from '../driverCollectionsTypes';
import styles from './CollectionsTable.module.css';

interface CollectionsTableProps {
  rows: CollectionRow[];
  onRecordPayment?: (id: string) => void;
  onViewReceipt?: (id: string) => void;
}

export const CollectionsTable: React.FC<CollectionsTableProps> = ({
  rows,
  onRecordPayment,
  onViewReceipt,
}) => {
  return (
    <div className={styles.card}>
      <h3 className={styles.title}>Collections</h3>
      <div className={styles.tableWrap}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>DELIVERY ID</th>
              <th>CUSTOMER</th>
              <th>INVOICE #</th>
              <th>AMOUNT DUE</th>
              <th>PAYMENT TYPE</th>
              <th>STATUS</th>
              <th>ACTION</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id}>
                <td className={styles.bold}>{row.deliveryId}</td>
                <td>{row.customer}</td>
                <td>{row.invoiceNumber}</td>
                <td className={styles.amount}>{row.amountDue}</td>
                <td>
                  <span className={`${styles.tag} ${styles[`tag_${row.paymentType.toLowerCase()}`]}`}>
                    {row.paymentType}
                  </span>
                </td>
                <td>
                  <span className={`${styles.status} ${styles[`status_${row.status.toLowerCase()}`]}`}>
                    {row.status}
                  </span>
                </td>
                <td>
                  {row.status === 'Paid' ? (
                    <button
                      className={styles.btnSecondary}
                      onClick={() => onViewReceipt?.(row.id)}
                    >
                      View Receipt
                    </button>
                  ) : (
                    <button
                      className={styles.btnPrimary}
                      onClick={() => onRecordPayment?.(row.id)}
                    >
                      Record Payment
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};
